import { render } from "./P046.vue?vue&type=template&id=5bb2eaa6&scoped=true"
import script from "./P046.vue?vue&type=script&lang=js"
export * from "./P046.vue?vue&type=script&lang=js"

import "./P046.vue?vue&type=style&index=0&id=5bb2eaa6&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb2eaa6"]])

export default __exports__